import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Divider,
  Grid,
  IconButton,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { useFormContext } from './FormContext';

const Page3Knowledge: React.FC = () => {
  const { 
    formData, 
    errors, 
    handleChange, 
    handleProductServiceChange,
    addProductService,
    removeProductService
  } = useFormContext();

  return (
    <>
      <Typography variant="h6" gutterBottom sx={{ mt: 2, mb: 2, color: "primary.main" }}>
        Seção 3: Conhecimento Essencial (A Base de Dados)
      </Typography>
      <Typography variant="body2" gutterBottom sx={{ mb: 2, fontStyle: 'italic' }}>
        Estas são as informações práticas que o assistente precisa saber de cor.
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="subtitle1" gutterBottom>
            Produtos e/ou Serviços: Por favor, liste seus principais produtos ou serviços com uma breve descrição e preço.
          </Typography>
          
          {formData.productsServices.map((product, index) => (
            <Box key={index} sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={11}>
                  <Typography variant="subtitle2">
                    Produto/Serviço {index + 1}:
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  {index > 0 && (
                    <IconButton 
                      aria-label="delete"
                      onClick={() => removeProductService(index)}
                      color="error"
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Nome"
                    value={product.name}
                    onChange={(e) => handleProductServiceChange(index, 'name', e.target.value)}
                    sx={{ mb: 2 }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Descrição"
                    multiline
                    rows={2}
                    value={product.description}
                    onChange={(e) => handleProductServiceChange(index, 'description', e.target.value)}
                    sx={{ mb: 2 }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Preço"
                    value={product.price}
                    onChange={(e) => handleProductServiceChange(index, 'price', e.target.value)}
                  />
                </Grid>
              </Grid>
            </Box>
          ))}
          
          <Button 
            startIcon={<AddIcon />} 
            onClick={addProductService}
            variant="outlined"
            sx={{ mt: 1 }}
          >
            Adicionar Produto/Serviço
          </Button>
          {errors.productsServices && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {errors.productsServices}
            </Typography>
          )}
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            id="workingHours"
            label="Horário de Funcionamento"
            name="workingHours"
            value={formData.workingHours}
            onChange={handleChange}
            required
            error={!!errors.workingHours}
            helperText={errors.workingHours || ""}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            id="businessLocation"
            label="Localização e Endereço"
            name="businessLocation"
            value={formData.businessLocation}
            onChange={handleChange}
            helperText="Se aplicável"
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            id="googleMapsLink"
            label="Link do Google Maps"
            name="googleMapsLink"
            value={formData.googleMapsLink}
            onChange={handleChange}
            helperText="Se disponível"
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle1" gutterBottom>
            Informações de Contato:
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            id="phoneContact"
            label="Telefone (para ligações)"
            name="phoneContact"
            value={formData.phoneContact}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            id="emailContact"
            label="E-mail"
            name="emailContact"
            type="email"
            value={formData.emailContact}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            id="websiteUrl"
            label="Site"
            name="websiteUrl"
            value={formData.websiteUrl}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            id="socialMedia"
            label="Redes Sociais"
            name="socialMedia"
            value={formData.socialMedia}
            onChange={handleChange}
            helperText="Instagram, Facebook, etc."
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            id="paymentMethods"
            label="Formas de Pagamento Aceitas"
            name="paymentMethods"
            value={formData.paymentMethods}
            onChange={handleChange}
            helperText="Ex: Pix, cartão de crédito, dinheiro, boleto"
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle1" gutterBottom>
            Informações sobre Entrega/Envio: (Se aplicável)
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            id="deliveryAreas"
            label="Áreas de entrega"
            name="deliveryAreas"
            value={formData.deliveryAreas}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            id="deliveryFee"
            label="Taxa de entrega"
            name="deliveryFee"
            value={formData.deliveryFee}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            id="deliveryTime"
            label="Prazo de entrega"
            name="deliveryTime"
            value={formData.deliveryTime}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Page3Knowledge;